define('Utilities.CookieJar', [
], function UtilitiesCookieJar(

) {
    'use strict';

    return {
        getItem: function getItem(sKey) {
            return decodeURIComponent(
                document.cookie.replace(
                    new RegExp(
                        '(?:(?:^|.*;)\\s*' +
                        encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, '\\$&') +
                        '\\s*\\=\\s*([^;]*).*$)|^.*$'
                    ), '$1'
                )
            ) || null;
        },
        setItem: function setItem(sKey, sValue, vEnd, sPath, sDomain, bSecure) {
            var sExpires = '';

            if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) { return false; }

            if (vEnd) {
                switch (vEnd.constructor) {
                case Number:
                    sExpires = vEnd === Infinity ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT' : '; max-age=' + vEnd;
                    break;
                case Date:
                    sExpires = '; expires=' + vEnd.toUTCString();
                    break;
                default:
                    sExpires = '; expires=' + vEnd;
                    break;
                }
            }
            document.cookie = encodeURIComponent(sKey) + '=' +
                encodeURIComponent(sValue) + sExpires +
                (sDomain ? '; domain=' + sDomain : '') +
                (sPath ? '; path=' + sPath : '') + (bSecure ? '; secure' : '');
            return true;
        },
        removeItem: function (sKey, sPath, sDomain) {
            if (!sKey || !this.hasItem(sKey)) { return false; }
            document.cookie = encodeURIComponent(sKey) +
                '=; expires=Thu, 01 Jan 1970 00:00:00 GMT' +
                (sDomain ? '; domain=' + sDomain : '') +
                (sPath ? '; path=' + sPath : '');
            return true;
        },
        hasItem: function (sKey) {
            return (
                new RegExp(
                    '(?:^|;\\s*)' +
                    encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\='
                )
            ).test(document.cookie);
        }
    };
});
